import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog"
import { ScrollArea } from "@/components/ui/scroll-area"
import KeywordNotificationSettingsForm from "./KeywordNotificationSettingsForm"

interface KeywordNotificationSettingsSheetProps {
  keywordId: string | null
  isOpen: boolean
  onClose: () => void
}

export default function KeywordNotificationSettingsSheet({
  keywordId,
  isOpen,
  onClose,
}: KeywordNotificationSettingsSheetProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-5xl w-[90vw] max-h-[90vh] overflow-hidden">
        <DialogHeader>
          <DialogTitle>關鍵字新串文通知</DialogTitle>
          <DialogDescription>
            Threads 上出現關鍵字時，立即通知您！
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="h-[calc(90vh-140px)] pr-4">
          {keywordId && (
            <KeywordNotificationSettingsForm
              keywordId={keywordId}
              onSuccess={onClose}
            />
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
